"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCampaign = exports.getPathway = exports.getPreviewWithDeliveryId = exports.searchWithCredentialNoAnon = exports.getSingleUser = exports.getuserByUserName = exports.getCertificates = void 0;
const constants_1 = require("../../constants/constants");
const axiosConfig_1 = require("../axios/axiosConfig");
// with V2 now it works with badges. For only certificates use Routes.getCertificatesAnon
const getCertificates = (username) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.SearchRoutes.getCredentialsByEmail(), {
            email: username,
        });
        return response.data;
    }
    catch (err) {
        console.log(err);
        return {};
    }
});
exports.getCertificates = getCertificates;
const getuserByUserName = (userName) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield (0, axiosConfig_1.getAxiosInstance)().get(`${constants_1.SearchRoutes.getUserByUsername}/${userName}`);
        return response.data;
    }
    catch (err) {
        console.log(err);
        throw err;
    }
});
exports.getuserByUserName = getuserByUserName;
const getSingleUser = (email) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.SearchRoutes.getSingleUser(), {
            query: email,
        });
        return response;
    }
    catch (error) {
        console.log(error);
        return null;
    }
});
exports.getSingleUser = getSingleUser;
const searchWithCredentialNoAnon = (credential_no, language, url, referrerUrl, viewerId) => __awaiter(void 0, void 0, void 0, function* () {
    // with V2 now it works with badges. For only certificates use V1
    try {
        let response = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.SearchRoutes.searchAnon(), {
            credential_no: credential_no,
            language: language,
            referrer_url: url,
            user_id: viewerId,
        });
        return response.data;
    }
    catch (err) {
        console.log(err);
        let errstring = JSON.stringify(err, Object.getOwnPropertyNames(err));
        //sendErrorLog(errstring, url);
        return {};
    }
});
exports.searchWithCredentialNoAnon = searchWithCredentialNoAnon;
const getPreviewWithDeliveryId = (delivery_id, language, url, certNo) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.SearchRoutes.credentialPreview(), {
            deliveryId: delivery_id,
            language: language,
            certificateNo: certNo,
        });
        return response.data;
    }
    catch (err) {
        console.log(err);
        let errstring = JSON.stringify(err, Object.getOwnPropertyNames(err));
        // sendErrorLog(errstring, url);
        return {};
    }
});
exports.getPreviewWithDeliveryId = getPreviewWithDeliveryId;
const getPathway = (pathwayId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.SearchRoutes.getPathway(), {
            id: pathwayId,
        });
        const pathway = response.data.pathway;
        return pathway;
    }
    catch (err) {
        console.log(err);
        throw err;
    }
});
exports.getPathway = getPathway;
const getCampaign = (campaignId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.SearchRoutes.getCampaign(), {
            id: campaignId,
        });
        const campaign = response.data;
        return campaign;
    }
    catch (err) {
        console.log(err);
        throw err;
    }
});
exports.getCampaign = getCampaign;
